export const styles = {
  container: {
    minHeight: "100vh",
    height: "100%",
    background: "#5F4DC7",
    position: "relative",
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    WebkitOverflowScrolling: "touch",
    msOverflowStyle: "auto", // For IE/Edge
    scrollbarWidth: "auto", // For Firefox
    "-webkit-tap-highlight-color": "transparent", // Prevent tap highlight on mobile
  },
  bottomImg: {
    position: "absolute",
    top: "20px",
    left: "20px",
    height: "24px",
    zIndex: 10,
  },

  backArrow: {
    position: "absolute",
    top: "40px",
    left: "20px",
    height: "24px",
    zIndex: 20,
  },

  backgroundWave: {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    height: "100vh",
  },

  mainContent: {
    maxWidth: { base: "100%", md: "900px" },
    py: 8,
    marginTop: "40px",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    zIndex: 10,
    overflowY: "scroll", // Changed from 'auto' to 'scroll'
    paddingBottom: { base: "100px", md: "50px" },
    css: {
      // Hide scrollbar for Chrome, Safari and Opera
      "&::-webkit-scrollbar": {
        display: "none",
      },

      // Hide scrollbar for IE, Edge and Firefox
      "-ms-overflow-style": "none", // IE and Edge
      scrollbarWidth: "none", // Firefox

      // Additional cross-browser method
      "&": {
        "-webkit-scrollbar": {
          display: "none",
        },
      },

      // Ensure smooth scrolling
      WebkitOverflowScrolling: "touch",

      // Fallback for browsers that don't support above methods
      overflow: "-moz-scrollbars-none",
    },
  },

  // Rest of the styles remain the same...
  stepIndicator: {
    px: { base: 2, md: 4 },
    borderRadius: "full",
    color: "white",
    colorScheme: "#5F4DC7",
    size: "lg",
    py: "4px",
    borderColor: "#FFFFFF99",
    borderWidth: "1px",
    fontSize: { base: "sm", md: "md" },
  },

  selectedStepIndicator: {
    px: { base: 2, md: 4 },
    borderRadius: "full",
    color: "white",
    colorScheme: "#5F4DC7",
    size: "lg",
    py: "4px",
    borderColor: "#FFFFFF",
    borderWidth: "1px",
    fontSize: { base: "sm", md: "md" },
  },

  lottieBox: {
    marginTop: "-50px",
    width: "240px",
    height: "200px",
    transition: "margin .5s",
  },

  stepDivider: {
    width: { base: 6, md: 10 },
    height: 0.5,
    bg: "whiteAlpha.400",
  },

  avatar: {
    width: "100%",
    height: "90px",
    margin: "0 auto",
  },

  wave: {
    position: "fixed",
    bottom: "0px",
    zIndex: 10,
  },

  heading: {
    fontSize: "xl",
    fontWeight: "bold",
    color: "white",
    paddingBottom: "16px",
  },

  subtext: {
    fontSize: "xl",
    color: "white",
  },

  questionSubText: {
    mt: "32px",
    fontSize: "xl",
    color: "white",
  },

  question: {
    fontSize: "xl",
    fontWeight: "bold",
    color: "white",
    textAlign: "center",
    paddingBottom: "16px",
  },

  traitGrid: {
    gap: { base: 2, md: 3 },
    width: "100%",
    justifyContent: "center",
    px: { base: 2, md: 4 },
  },

  traitBox: {
    w: { base: "80px", md: "96px" },
    h: { base: "80px", md: "96px" },
    aspectRatio: 1,
    bg: "#8877EA",
    borderRadius: "8px",

    p: 0.5,
    cursor: "pointer",
    borderColor: "#FFFFFF",
    _hover: { borderWidth: "1px" },
  },

  mobileTraitBox: {
    w: { base: "80px", md: "96px" },
    h: { base: "80px", md: "96px" },
    aspectRatio: 1,
    bg: "#8877EA",
    borderRadius: "8px",

    p: 0.5,
    cursor: "pointer",
    borderColor: "#FFFFFF",
    _hover: { borderWidth: "1px" },
  },

  selectedTraitBox: {
    w: { base: "80px", md: "96px" },
    h: { base: "80px", md: "96px" },
    aspectRatio: 1,
    bg: "#5F4DC7",
    borderRadius: "8px",
    p: 0.5,
    cursor: "pointer",
    transition: "all 0.2s",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    _hover: { borderWidth: "1px" },
  },

  mobileSelectedTraitBox: {
    w: { base: "80px", md: "96px" },
    h: { base: "80px", md: "96px" },
    aspectRatio: 1,
    bg: "#5F4DC7",
    borderRadius: "8px",
    p: 0.5,
    cursor: "pointer",
    transition: "all 0.2s",
    borderColor: "whiteAlpha",
    borderWidth: "1px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    _hover: { borderWidth: "1px" },
  },

  traitImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  nextButton: {
    colorScheme: "#5F4DC7",
    size: "lg",
    height: "48px",
    py: "10px",
    borderColor: "whiteAlpha",
    borderWidth: "2px",
    width: { base: "140px", md: "160px" },
    _hover: {
      background: "#5551ff",
      borderColor: "whiteAlpha",
      textColor: "whiteAlpha",
    },
  },

  startTour: {
    colorScheme: "#5F4DC7",
    size: "lg",
    height: "48px",
    py: "10px",
    borderColor: "whiteAlpha",
    borderWidth: "2px",
    _hover: {
      background: "#5551ff",
      borderColor: "whiteAlpha",
      textColor: "whiteAlpha",
    },
  },

  backButton: {
    colorScheme: "##FFFFFF99",
    size: "lg",
    height: "48px",
    py: "10px",
    textColor: "#FFFFFF99",
    borderColor: "#FFFFFF99",
    borderWidth: "2px",
    width: { base: "140px", md: "160px" },
    _hover: {
      background: "#5551ff",
      borderColor: "whiteAlpha",
      textColor: "whiteAlpha",
    },
  },

  skipButton: {
    variant: "ghost",
    textColor: "#FFFFFF73",
    size: "sm",
    _hover: { textColor: "whiteAlpha.600" },
  },

  buttonContainer: {
    width: "100%",
    px: 4,
    spacing: 2,
    mt: { base: 2, md: 4 },
  },
};

export const breakpoints = {
  columns: {
    base: 3,
    md: 5,
  },
};
